import { createAction, props } from '@ngrx/store';

import { ApiError } from '@error/models/api-error';
import { FeatureCollection } from '@settings/models/map/feature-collection';
import { CustomerSettings } from '@settings/models/settings/customer-settings';
import { NewMatchSettings } from '@settings/models/settings/new-match-settings';
import { NewMatchSettingsRequest } from '@settings/models/settings/new-match-settings-request';

export const removeSettingsError = createAction('[Settings] Remove Settings Error');

export const loadSettings = createAction('[Settings] Load Settings');
export const loadSettingsSuccessful = createAction('[Settings] Load Settings Successful', (settings: CustomerSettings) => settings);
export const loadSettingsFailed = createAction('[Settings] Load Settings Failed', (error: ApiError) => error);

export const loadNewMatchSettings = createAction('[Settings] Load New Match Settings');
export const loadNewMatchSettingsSuccessful = createAction('[Settings] Load New Match Settings Successful', props<{ settings: NewMatchSettings }>());
export const loadNewMatchSettingsFailed = createAction('[Settings] Load New Match Settings Failed', (error: ApiError) => error);

export const updateSettings = createAction('[Settings] Update Settings', props<{ newSettings: CustomerSettings, oldSettings: CustomerSettings }>());
export const updateSettingsSuccessful = createAction('[Settings] Update Settings Successful');
export const updateSettingsFailed = createAction('[Settings] Update Settings Failed', (error: ApiError, settings: CustomerSettings) => ({ error, settings }));

export const updateNewMatchSettings = createAction('[Settings] Update New Match Settings', props<{ request: NewMatchSettingsRequest }>());
export const updateNewMatchSettingsSuccessful = createAction('[Settings] Update New Match Settings Successful');
export const updateNewMatchSettingsFailed = createAction('[Settings] Update New Match Settings Failed', (error: ApiError, settings: NewMatchSettings) => ({ error, settings }));

export const loadNeighborhoodsMapping = createAction('[Settings] Load Neighborhoods Mapping');
export const loadNeighborhoodsMappingSuccessful = createAction(
    '[Settings] Load Neighborhoods Mapping Successful',
    (neighborhoodsMapping: FeatureCollection[]) => ({ neighborhoods: neighborhoodsMapping })
);
export const loadNeighborhoodsMappingFailed = createAction('[Settings] Load Neighborhoods Mapping Failed', (error: ApiError) => error);

export const saveLoadedSettings = createAction('[Settings] Save Loaded Settings', (settings: CustomerSettings, isInitialSave: boolean) => ({ settings, isInitialSave }));

export const setSettings = createAction('[Settings] Set Settings', props<{ settings: CustomerSettings }>());

export const changeSystemFoldersVisibility = createAction('[Settings] Change System Folders Visibility');

export const resetState = createAction('[Settings] Reset State');